export default "__VITE_ASSET__Be92RivK__"